import React, { FunctionComponent } from 'react';

import { createStyles, makeStyles } from '@material-ui/core/styles';
import { AppBar, Toolbar, Typography } from '@material-ui/core';

import logoIcon from '../../assets/image/logo.svg';
import LanguageSelect from '../shared/LanguageSelect';

interface TitleBarProps {
  lastName?: string;
  firstName?: string;
}

const useStyles = makeStyles((theme) =>
  createStyles({
    titlebar: {
      width: '100%',
      height: 56,
      padding: 0,
      margin: 0,
      boxShadow: '0 1px 1px rgba(0, 0, 0, 0.25)',
    },
    toolbar: {
      flexWrap: 'wrap',
      height: 56,
      minHeight: 56,
      paddingLeft: 0,
    },
    logo: {
      height: 27,
      marginLeft: 10,
    },
    branding: {
      marginLeft: 10,
      verticalAlign: 'middle',
      userSelect: 'none',
      fontSize: 24,
      fontWeight: 400,
    },
    toolbarTitle: {
      flexGrow: 1,
      marginLeft: 10,
    },
    firstName: {
      fontSize: 32,
      fontWeight: 'normal',
    },
    lastName: {
      fontSize: 32,
      fontWeight: 'bold',
    },
    spacer: {
      flexGrow: 1,
    },
  })
);

const TitleBar: FunctionComponent<TitleBarProps> = ({ lastName, firstName }: TitleBarProps) => {
  const classes = useStyles();

  return (
    <AppBar position="static" color="transparent" elevation={0} className={classes.titlebar}>
      <Toolbar className={classes.toolbar}>
        <img src={logoIcon} className={classes.logo} />
        <Typography variant="h1" color="inherit" className={classes.branding}>
          <b>CS</b> WebViewer
        </Typography>

        {/*
        firstName && (
          <Typography
            variant="h4"
            color="inherit"
            className={classes.firstName}
          >
            {firstName},
          </Typography>
        )
        */}
        {/*
        lastName && (
          <Typography variant="h4" color="inherit" className={classes.lastName}>
            {lastName}
          </Typography>
        )
        */}
        <Typography variant="h4" color="inherit" className={classes.spacer}></Typography>
        <LanguageSelect />
      </Toolbar>
    </AppBar>
  );
};

export default TitleBar;
